var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('p',[_vm._v(_vm._s(_vm.element.config.question))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.element.config.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }